module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"reported_post":"我举报/屏蔽的帖子"}}')
  delete Component.options._Ctor
}
